import { UpdateReason } from 'APP/constants/scroll';
import Entities from 'STORE';

export function scrollToLastMessage(): void {
  const group = Entities.GroupsStore.activeGroup;
  if (!group || !group.counter?.lastMessage) {
    return;
  }

  Entities.ChatStore.setScrollChanged(UpdateReason.ScrollToBottom, {
    isAnimated: true,
  });
}
